import {handleLogout} from "components/utils";
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react';
import {Button, Card, Col, Form, Modal, Row} from "react-bootstrap";
import axios from "axios";
import 'react-vertical-timeline-component/style.min.css';
import {AddDiagnosticTestView} from "./AddDiagnosticTestView";
import {DiagnosticRecordView} from "./DiagnosticRecordView";
import ReactToPrint from "react-to-print";
import {LabRecordsPrintView} from "./lab/LabRecordsPrintView";
import {random} from "nanoid";

export const DiagnosticsVisitView = forwardRef((props: { visitId: string, uhid: string, shouldAddNew: boolean, entityQr: string, diagnosticCategory: string, source: string, createVisit: any}, ref) => {


    const [servicesProvided, setServicesProvided] = useState<Array<any>>([]);
    const [tests, setTests] = useState<Array<any>>([]);
    const [referringDr, setReferringDr] = useState<null>();
    const [labTests, setLabTests] = useState<Array<any>>([]);
    const [recordType, setRecordType] = useState<string>();
    const [services, setServices] = useState<Array<any>>();
    const [stateTracker, setStateTracker] = useState<any>(random(2));

    function fetchRecords() {
        fetchRecordsUsingVisitId(props.visitId)
        setStateTracker(random(2))
    }

    function fetchRecordsUsingVisitId(visitId) {
        axios.get('/api/backend/customer/records/fetch/all/' + props.uhid + '/' + visitId)
            .then(resp => {
                console.log(JSON.stringify(resp))
                setReferringDr(resp.data.referringDr)
                if (props.diagnosticCategory == "LAB") {
                    setLabTests(resp.data.records.filter(r => r.category == "Lab"))
                } else if (props.diagnosticCategory == "RADIOLOGY") {
                    setTests(resp.data.records.filter(r => r.category == "Radiology"))
                } else {
                    setServicesProvided(resp.data.records.filter(r => r.reportStatus == "NOT_REQUIRED"))
                    setTests(resp.data.records.filter(r => r.reportStatus != "NOT_REQUIRED" && r.category != "Lab"))
                    setLabTests(resp.data.records.filter(r => r.category == "Lab"))
                }
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
                ;
            });
    }

    function fetchServices() {
        axios.get('/api/backend/inventory/item/fetch/all/' + props.entityQr + "?type=SERVICE")
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                const services = resp.data.filter(d => d.category == "Medical Services")
                setServices(services)
                if (resp.data && resp.data.length > 0) setRecordType(services[0].name)
            })
            .catch(err => {
                console.error(err);
                if (err.response && err.response!.status && err.response!.status === 403) {
                    handleLogout()
                }
            })
    }


    useEffect(() => {
        if (props.uhid && props.visitId) {
            fetchRecords();
        }
        if (props.entityQr) {
            fetchServices();
        }

    }, [props.uhid, props.visitId, props.shouldAddNew, props.entityQr])


    function getAddedTests() {
        return <>
            <div className="border p-2 mb-3 overflow-scroll">
                <table className="table">
                    <thead>
                    <tr>
                        <th>Medical Service</th>
                        <th>Report Status</th>
                        <th>&#128206;</th>
                        {props.shouldAddNew && <th></th>}
                    </tr>
                    </thead>
                    {tests.map((record) => {
                        return <DiagnosticRecordView key={record.id} record={record}
                                                     fetchRecords={fetchRecords} isActive={props.shouldAddNew}
                                                     category={record.category} uhid={props.uhid} entityQr={props.entityQr}
                                                     stateTracker={stateTracker} referringDr={referringDr}/>
                    })}
                </table>
            </div>
        </>;
    }

    function getLabTests() {
        return <>
            <div className="border p-2 mb-3 overflow-scroll">
                <table className="table">
                    <thead>
                    <tr>
                        <th>Medical Service</th>
                        <th>Report Status</th>
                        {props.shouldAddNew && <th></th>}
                    </tr>
                    </thead>
                    {labTests.map((record) => {
                        return <DiagnosticRecordView key={record.id} record={record}
                                                     fetchRecords={fetchRecords} isActive={props.shouldAddNew}
                                                     category={"Lab"} uhid={props.uhid} entityQr={props.entityQr}
                                                     stateTracker={stateTracker} referringDr={referringDr}/>
                    })}
                </table>
            </div>
        </>;
    }

    function getServicesProvided() {
        return <>
            {servicesProvided.map(r => r.recordType).join(", ")}
        </>;
    }


    return (
        <div>
            {props.shouldAddNew &&
                <div className="col col-12">
                    <AddDiagnosticTestView visitId={props.visitId} source={props.source} uhid={props.uhid}
                                           entityQr={props.entityQr} postAction={fetchRecordsUsingVisitId}
                                           showSave={true}
                                           category={props.diagnosticCategory} createVisit={props.createVisit}/>
                </div>
            }
            {servicesProvided && servicesProvided.length > 0 &&
                <>
                    <div className="col col-12">
                        <div className="mt-3 fs-5 text-secondary">Services</div>
                        {getServicesProvided()}
                    </div>
                </>
            }
            {tests && tests.length > 0 &&
                <>
                    <div className="col col-12">
                        <div className="mt-3 fs-5 text-secondary">Tests</div>
                        {getAddedTests()}
                    </div>
                </>
            }
            {labTests && labTests.length > 0 &&
                <>
                    <div className="col col-12">
                        <div className="mt-3 d-flex gap-4">
                            <div className=" fs-5 text-secondary">Lab Tests</div>
                        </div>
                        {getLabTests()}
                    </div>
                </>
            }
        </div>
    );
});

DiagnosticsVisitView.displayName = "DiagnosticsVisitView";